module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-144x144.52990ce2.png";